export async function checkGoogleFactCheckTools() {
  return {
    provider: "Google Fact Check Tools API",
    enabled: false,
    message: "Placeholder only. No API key is required for the local MVP.",
  };
}

export async function checkMediaBiasFactCheck() {
  return {
    provider: "Media Bias Fact Check / MBFC API",
    enabled: false,
    message: "Placeholder only. No API key is required for the local MVP.",
  };
}

export async function checkAiDetectionProvider() {
  return {
    provider: "AI detection provider API",
    enabled: false,
    message: "Placeholder only. No API key is required for the local MVP.",
  };
}

